<template>
  <div>
    <div class="px-6">
      <div>
        <label class="text-lg font-semibold text-black mb-0"
          >Template Name</label
        >
        <el-input
          placeholder="Enter Template Name"
          v-model="templateName"
          v-validate="'required'"
          name="template"
          data-vv-validate-on="input|blur"
          class="w-full mt-2"
        ></el-input>
        <p v-if="errors.has('template')" class="text-danger">
          {{ errors.first("template") }}
        </p>
      </div>
      <div class="mt-6">
        <label class="text-lg font-semibold text-black mb-0">Sender ID</label>
        <el-select
          placeholder="Sender ID"
          class="w-full mt-2"
          value-key="_id"
          name="senderId"
          v-validate="'required'"
          data-vv-validate-on="input|blur"
          v-model="category"
        >
          <el-option
            v-for="item in senderIdOptions"
            :key="item._id"
            :label="item.email"
            :value="item"
          >
          </el-option>
        </el-select>
        <p v-if="errors.has('senderId')" class="text-danger">
          {{ errors.first("senderId") }}
        </p>
      </div>
      <div class="mt-6">
        <label class="text-lg font-semibold text-black mb-0">Subject</label>
        <el-input
          placeholder="Enter Template Name"
          v-model="subject"
          class="w-full mt-2"
          v-validate="'required'"
          name="subject"
          data-vv-validate-on="input|blur"
        ></el-input>
        <p v-if="errors.has('subject')" class="text-danger">
          {{ errors.first("subject") }}
        </p>
      </div>
      <div class="mt-6">
        <label class="text-lg font-semibold text-black mb-0">Email Body</label>
        <el-input
          placeholder="Enter Template Name"
          v-model="body"
          type="textarea"
          class="w-full mt-2"
          :autosize="{ minRows: 8, maxRows: 8 }"
          v-validate="'required'"
          name="emailBody"
          data-vv-validate-on="input|blur"
        ></el-input>
        <p v-if="errors.has('emailBody')" class="text-danger">
          {{ errors.first("emailBody") }}
        </p>
      </div>
      <!-- <div class="mt-6">
        <label class="text-lg font-semibold text-black mb-0">Example</label>
        <el-input
          placeholder="Enter Template Name"
          v-model="example"
          type="textarea"
          class="w-full mt-2"
          :autosize="{ minRows: 8, maxRows: 8 }"
        ></el-input>
      </div> -->
    </div>

    <div class="flex justify-center mt-10">
      <vs-button
        @click="handleSubmit()"
        class="bgraw rounded-full border-0 col-purple font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
      >
        Submit
      </vs-button>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-quill-editor";
import { mapState } from "vuex";

export default {
  data() {
    return {
      templateName: "",
      subject: "",
      body: "",
      example: "",
      category: "",
      senderIdOptions: [],
    };
  },
  props: {
    drawer: { type: Boolean },
  },
  watch: {
    drawer(value) {
      if (value) {
        this.$validator.reset();
        this.errors.clear();
      }
    },
  },
  methods: {
    async getEmailConfigHandler() {
      let payload = {
        projectId: this.selectedProject._id,
        // communityName: this.selectedProject.projectName,
      };
      try {
        await this.$store.dispatch("email/getEmailConfig", payload);
        this.senderIdOptions = this.getEmailConfig;
      } catch (error) {}
    },
    async handleSubmit() {
      try {
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            let payload = {
              templateName: this.templateName,
              subject: this.subject,
              body: this.body,
              senderId: this.category,
              projectId: this.selectedProject._id,
              projectName: this.selectedProject.projectName,
              displayName: this.selectedProject.displayName,
            };

            let data = await this.$store.dispatch(
              "controlCenter/create",
              payload
            );

            if (data.code == 200) {
              this.$swal({
                title: "SUCCESS",
                text: "Email Template is successfully submitted",
                icon: "success",
                confirmButtonColor: "#830c81",
                confirmButtonText: "OK",
              });
              this.templateName = "";
              this.subject = "";
              this.body = "";
              this.$emit("apiCall");
            }
          }
        });

        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    this.getEmailConfigHandler();
  },
  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("admin", { login: "login" }),
    ...mapState("email", ["getAllEmailTemplate", "getEmailConfig"]),
  },
  components: {
    VueEditor,
  },
};
</script>
